import React, {useState} from 'react';
import PropTypes from 'prop-types';
import AbstractModalView from 'common/components/AbstractModalView';
import AnimatedProgress from '../../../../common/components/AnimatedProgress';
import {getGoogleMapCoordinatesByAddress} from '../../utils/googleMaps';
import {errors as E} from 'common/constants/errors';
import google from '../../../../config/google';
import styles from './styles.module.scss';

const GoogleStreetViewImagePopup = ({
                                      buttonLabel,
                                      buttonIcon,
                                      buttonClassName,
                                      onButtonClick,
                                      address,
                                      showGlobalErrorMessage,
                                      onFileApproved,
                                      ...rest
                                    }) => {
  const [img, setImg] = useState(null);

  const getImage = ({lat, lng}) => {
    const url = `https://maps.googleapis.com/maps/api/streetview?size=600x300&location=${lat},${lng}&heading=151.78&pitch=-0.76&key=${google.apiKey}`;
    setImg(url);
  };

  const handleNoData = closeModal => (message) => {
    closeModal();
    showGlobalErrorMessage(message);
  };

  const handleOpenModal = (openModal, closeModal) => e => {
    e.stopPropagation();
    e.preventDefault();
    if (Boolean(address)) {
      getGoogleMapCoordinatesByAddress(address)
        .then(getImage)
        .catch(err => {
          handleNoData(closeModal)(err.message);
        });
      openModal();
    } else {
      showGlobalErrorMessage(E.FILL_ADDRESS);
    }
    if (onButtonClick) {
      onButtonClick();
    }
  };

  const handleUpload = closeModal => () => {
    if (Boolean(img)) {
      fetch(img)
        .then(res => res.blob())
        .then(file => {
          file.name = `google-street-maps-captured-image.png`;
          onFileApproved(file);
          closeModal();
        });
    }
  };

  const handleCancel = closeModal => () => {
    setImg(null);
    closeModal();
  };

  return (
    <AbstractModalView
      subPath={'api-confirmation'}
      triggerContent={({openModal, closeModal}) => (
        <div
          className={buttonClassName}
          onClick={handleOpenModal(openModal, closeModal)}
          {...rest}
        >
          <img
            src={buttonIcon}
            className={styles.apiIcon}
            alt="apiIcon"
          />
          <div>{buttonLabel}</div>
        </div>
      )}
      modalContent={({closeModal}) => (
        <>
          <div className={styles.modalContentContainer}>
            {img
              ? (
                <div className={styles.modalApiImage}>
                  <img src={img} alt="map" className={styles.image}/>
                </div>
              )
              : (
                <div className={styles.modalApiImageDumb}>
                  <AnimatedProgress/>
                </div>
              )
            }
            <div className={styles.modalButtons}>
              <button
                type="button"
                className={styles.buttonCancel}
                onClick={handleCancel(closeModal)}
              >
                <span>ביטול</span>
              </button>
              <button
                type="button"
                className={styles.buttonSubmit}
                onClick={handleUpload(closeModal)}
              >
                <span>אשר והוסף לשומה</span>
              </button>
            </div>
          </div>
        </>
      )}
    />
  );
};

GoogleStreetViewImagePopup.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  buttonIcon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  buttonClassName: PropTypes.string,
  onButtonClick: PropTypes.func,
  address: PropTypes.string,
  onFileApproved: PropTypes.func.isRequired,
  showGlobalErrorMessage: PropTypes.func,
};

export default GoogleStreetViewImagePopup;
